import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/* The HTML5 Banners library draws on the shared ad library shell (grid, cards, archived sheet); these are its own
   pieces: the card poster and the style step of a new banner. */

export { PosterEmpty, PosterImg, PosterPlaceholder } from '../AdLibraryShell/AdLibraryShell.styles';
export { FootActions, Hint, Section, SectionHead, SectionTitle } from '../BannerKitComposer/BannerKitComposer.styles';

/* ── A new banner's style step (and its note while the draft is minted) ── */

export const StepBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[16]};
`;

export const MintingText = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;
